import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react'
import { backendUrl } from './utils/variables'
import { fetchAllowlistedAdmin } from './utils/adminAccess'
export const MyContext = React.createContext();

const NOTIFICATION_STORAGE_KEY = 'sc_chat_last_notification_check';
const NOTIFICATION_DISMISSED_STORAGE_KEY = 'sc_chat_dismissed_notification_ids';
const NOTIFICATION_POLL_INTERVAL_MS = 30000;

export default function MainContext({ children }) {

  const [user, setUser] = useState({})
  const [userData, setUserData] = useState({})
  const [current_insight, setCurrentInsight] = useState({})
  const [adminData, setAdminData] = useState(null)
  const [notificationToasts, setNotificationToasts] = useState([])
  const lastNotificationCheckRef = useRef(null)
  const dismissedNotificationIdsRef = useRef(new Set())
  const MAX_DISMISSED_IDS = 50

  const persistDismissedIds = useCallback(() => {
    const arr = [...dismissedNotificationIdsRef.current].slice(-MAX_DISMISSED_IDS);
    storage.setItem(NOTIFICATION_DISMISSED_STORAGE_KEY, arr);
  }, []);

  const storage = {

    setItem: (key, value) => {
      localStorage.setItem(key, JSON.stringify(value));
    },
    getItem: (key) => {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : null;
    },
    removeItem: (key) => {
      localStorage.removeItem(key);
    },
    clear: () => {
      //localStorage.clear();
      localStorage.removeItem("sc_chat");
    }
  };


  useEffect(() => {

    const user_ = storage.getItem('sc_chat');

    if (user_ && user_.user_id) {

      //console.log('user stance found')

      setUser(user_)

    }

  }, []);



  useEffect(() => {


    if (user && user.user_id) {

      storage.setItem('sc_chat', user);

      //console.log('user data updated', user.username)


    } else {

      //

    }

  }, [user]);

  // Platform admin access from server allowlist (admin_emails.php)
  useEffect(() => {
    let cancelled = false;
    const loadAdmin = async () => {
      if (!user?.email) {
        setAdminData(null);
        return;
      }
      const admin = await fetchAllowlistedAdmin(user.email);
      if (!cancelled) {
        setAdminData(admin);
      }
    };
    loadAdmin();
    return () => { cancelled = true; };
  }, [user?.email]);

  useEffect(() => {
    if (!user?.user_id) return;
    const saved = storage.getItem(NOTIFICATION_DISMISSED_STORAGE_KEY);
    if (Array.isArray(saved) && saved.length > 0) {
      dismissedNotificationIdsRef.current = new Set(saved);
    }
  }, [user?.user_id]);

  const removeNotificationToast = useCallback((id) => {
    const idStr = String(id);
    dismissedNotificationIdsRef.current.add(idStr);
    if (dismissedNotificationIdsRef.current.size > MAX_DISMISSED_IDS) {
      const arr = [...dismissedNotificationIdsRef.current];
      dismissedNotificationIdsRef.current = new Set(arr.slice(-MAX_DISMISSED_IDS));
    }
    persistDismissedIds();
    setNotificationToasts((prev) => prev.filter((t) => String(t.id) !== idStr));
  }, [persistDismissedIds]);

  const clearAllNotificationToasts = useCallback(() => {
    setNotificationToasts((prev) => {
      prev.forEach((t) => dismissedNotificationIdsRef.current.add(String(t.id)));
      if (dismissedNotificationIdsRef.current.size > MAX_DISMISSED_IDS) {
        const arr = [...dismissedNotificationIdsRef.current];
        dismissedNotificationIdsRef.current = new Set(arr.slice(-MAX_DISMISSED_IDS));
      }
      persistDismissedIds();
      return [];
    });
  }, [persistDismissedIds]);

  useEffect(() => {
    if (!user?.user_id) return;
    // Use the backendUrl imported from ./utils/variables
    // const backendUrl = process.env.REACT_APP_API_URL || 'https://api.clowza.com/api/schat';
    const poll = () => {
      const lastCheck = lastNotificationCheckRef.current || storage.getItem(NOTIFICATION_STORAGE_KEY) || null;
      fetch(backendUrl + '/get_unread_notifications.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: user.user_id, last_check: lastCheck, limit: 10 })
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success && data.notifications && data.notifications.length > 0) {
            const latest = data.notifications.reduce((a, n) => (n.created_at > (a && a.created_at) ? n : a), null);
            if (latest) lastNotificationCheckRef.current = latest.created_at;
            storage.setItem(NOTIFICATION_STORAGE_KEY, lastNotificationCheckRef.current);
            setNotificationToasts((prev) => {
              const seen = new Set(prev.map((t) => String(t.id)));
              const dismissed = dismissedNotificationIdsRef.current;
              const newOnes = data.notifications.filter(
                (n) => !seen.has(String(n.id)) && !dismissed.has(String(n.id))
              );
              return [...prev, ...newOnes];
            });
          }
        })
        .catch(() => { });
    };
    poll();
    const interval = setInterval(poll, NOTIFICATION_POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [user?.user_id]);

  const exit_user = useCallback(() => {

    storage.clear()
    storage.removeItem(NOTIFICATION_DISMISSED_STORAGE_KEY)
    setUser({})
    setAdminData(null)
    setNotificationToasts([])
    lastNotificationCheckRef.current = null
    dismissedNotificationIdsRef.current = new Set()
  }, [])


  const defaultValue = useMemo(() => ({

    user, setUser,
    userData, setUserData,
    exit_user,
    current_insight, setCurrentInsight,
    adminData, setAdminData,
    notificationToasts,
    removeNotificationToast,
    clearAllNotificationToasts

  }), [user, userData, current_insight, adminData, exit_user, notificationToasts, removeNotificationToast, clearAllNotificationToasts])

  return (
    <MyContext.Provider value={defaultValue}>
      {children}
    </MyContext.Provider>
  )
}

